import { BatchSearchEngineModel, BatchSearchEngineReceiptModel } from './batch-search-engine.model';

export class BlankFormBatchSearchEngineReceiptModel extends BatchSearchEngineReceiptModel {

}

export class BlankFormBatchSearchEngineModel extends BatchSearchEngineModel {

}
